import { render, staticRenderFns } from "./DialogDNI.vue?vue&type=template&id=38855bf6&scoped=true&"
import script from "./DialogDNI.vue?vue&type=script&lang=js&"
export * from "./DialogDNI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38855bf6",
  null
  
)

export default component.exports